import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Order, ProcessType, Product} from "../../../../../store/state/order.state";
import {FormGroup} from "@angular/forms";
import {Observable} from "rxjs";
import {AuditDatesFormService} from "../audit-dates-form.service";

@Component({
    selector: 'transfer-dates',
    templateUrl: './transfer-dates.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TransferDatesComponent implements OnInit, OnDestroy {

	@Input() order: Order;
	@Input() product: Product;

	form: FormGroup;

	constructor(private formService: AuditDatesFormService) {
	}

	ngOnInit(): void {
		this.form = this.formService.buildSubForm(this.product.standard.name, this.totalSubForms(this.order), ProcessType.TRANSFER, this.product);
	}

	ngOnDestroy(): void {
		this.formService.destroySubForm(this.product.standard.name);
	}

	updateDateFormControlAndValidateAllDates(dateFormControlName: string, value: any) {
		this.formService.updateFormControl(dateFormControlName, value, this.product.standard.name);
		this.formService.triggerSubFormValidations(this.product.standard.name);
	}

	get desiredNextAuditDate(): Date {
		return this.product.additionalQuestions.desiredNextAuditDate;
	}

	getErrorsIfInvalid(formControlName): Observable<string> {
		return this.formService.getErrorsIfInvalid(this.product.standard.name, formControlName);
	}

	isInvalid(formControlName: string) {
		if (this.formService.getFormControl(this.product.standard.name, formControlName)) {
			return this.formService.isInvalid(this.product.standard.name, formControlName);
		}
		return true;
	}

	totalSubForms(order: Order): number {
		return order.products.length;
	}
}
